import { CSSObject, SerializedStyles } from '@emotion/react';
import { Anchor, DropdownMenu, Icon } from '@anytag/shared-atoms';
import { LANGUAGE_OPTIONS } from '@anytag/shared-constants';
import { useQueryHelper } from '@anytag/shared-hooks';
import { DropdownOption } from '@anytag/shared-types';
import { cn } from '@anytag/shared-utils';

export interface SignInSignUpFooterProps {
  hasCopyRight?: boolean;
  className?: string | CSSObject | SerializedStyles;
}

export const SignInSignUpFooter = ({ hasCopyRight = true, className }: SignInSignUpFooterProps) => {
  const { t, i18n, pathname } = useQueryHelper();

  const handleLanguageSelect = (option: DropdownOption) => {
    i18n.changeLanguage(option.value);
  };

  return (
    <footer className={cn('flex w-[var(--dashboard-max-width)] items-center justify-between pt-4', className)}>
      {hasCopyRight ? <p className="mr-6 text-sm leading-[100%] text-tertiary">{t('CopyrightSentence')}</p> : null}

      <div className="flex">
        <Anchor
          className="cursor-pointer border-r-border px-3.5 py-0 text-center text-sm leading-4 font-normal text-tertiary"
          to="/privacy"
        >
          {t('Password.Privacy Policy')}
        </Anchor>

        <Anchor
          className="cursor-pointer border-r-border px-3.5 py-0 text-center text-sm leading-4 font-normal text-tertiary"
          to="/terms-combined"
        >
          {t('Password.Terms of Service')}
        </Anchor>

        <Anchor
          className="cursor-pointer border-r-border px-3.5 py-0 text-center text-sm leading-4 font-normal text-tertiary"
          href="https://anytag.jp/contact/"
          target="_blank"
        >
          {t('Contact')}
        </Anchor>

        <DropdownMenu
          trigger={
            <div className="cursor-pointer pl-3.5 text-center text-sm leading-4 font-normal text-tertiary hover:text-active">
              <span css={{ fontWeight: 'normal' }}>{t('languageTitle')}</span>
              <Icon size={7} css={{ marginLeft: '6px' }} icon="caret-down" variant="inherit" />
            </div>
          }
          options={LANGUAGE_OPTIONS}
          onSelectOption={handleLanguageSelect}
          align={pathname === '/sign-up' ? 'start' : 'end'}
        />
      </div>
    </footer>
  );
};
